export default {slug_name:'algolia',version:'0.0.1',link:'https://github.com/answerdev/plugins/tree/main/connector/',author:'Answer.dev'};